import React from 'react';
import SignUpRedeem from '../features/auth/components/SignUpRedeem';

const SignUpRedeemPage = () => {
    return <SignUpRedeem />;
};

export default SignUpRedeemPage;
